/**
 * Ore Mastery — cumulative milestones per ore (from stats.oreMined). Each
 * threshold passed grants a permanent mining bonus for that ore. No new state:
 * everything derives from how much of each ore you've ever mined.
 */
export const MASTERY = {
  /** Cumulative-mined thresholds; passing each grants one mastery tier. */
  thresholds: [1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9],
  /** Mining multiplier granted per mastery tier (per ore). */
  bonusPerTier: 0.05,
} as const;

export const MAX_MASTERY_TIER = MASTERY.thresholds.length;
